import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import o from "./styles/index.cssr.js";
import n from "../../../_mixins/use-style.js";
import { defineComponent as s, onBeforeUnmount as f, nextTick as u, h as v } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { toRef as m, ref as r } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const x = s({
  name: "BaseWave",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    n("-base-wave", o, m(t, "clsPrefix"));
    const l = r(null), i = r(!1);
    let e = null;
    return f(() => {
      e !== null && window.clearTimeout(e);
    }), {
      active: i,
      selfRef: l,
      play() {
        e !== null && (window.clearTimeout(e), i.value = !1, e = null), u(() => {
          var a;
          (a = l.value) === null || a === void 0 || a.offsetHeight, i.value = !0, e = window.setTimeout(() => {
            i.value = !1, e = null;
          }, 1e3);
        });
      }
    };
  },
  render() {
    const {
      clsPrefix: t
    } = this;
    return v("div", {
      ref: "selfRef",
      "aria-hidden": !0,
      class: [`${t}-base-wave`, this.active && `${t}-base-wave--active`]
    });
  }
});
export {
  x as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/wave/src/Wave.js
// module id = 1570
// module chunks = 41